module.exports = __webpack_public_path__ + "media/bootstrap-icons/flower3-0e7da69c.svg";